import { render, staticRenderFns } from "./WDDealer.vue?vue&type=template&id=258930a1&"
import script from "./WDDealer.vue?vue&type=script&lang=js&"
export * from "./WDDealer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports